import React from 'react';

export const RankedVoting = () => {
  return (
    <div>
      <h1>this is the Ranked Voting page</h1>
    </div>
  );
};
